// src/components/StateRules.jsx (s112, Phase 4b) — state-level rules (b3, working at height) on the state page,
// from STATE_RULES in src/data/localRules.js. City pages link here rather than repeat the text.
import React from 'react';
import { Link } from 'react-router-dom';
const MONTH = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const checked = (ym) => { const [y, m] = String(ym).split('-'); return `${MONTH[Number(m) - 1]} ${y}`; };
export default function StateRules({ rules, T, fontDisplay, fontMono }) {
  const v = rules?.height; if (!v) return null;
  return (
    <div id="working-at-height" data-region="state-rules" style={{ marginTop: 56, scrollMarginTop: 24 }}>
      <div style={{ fontFamily: fontMono, fontSize: 11, letterSpacing: '0.18em', color: T.sienna, marginBottom: 14 }}>WORKING AT HEIGHT</div>
      <h2 style={{ fontFamily: fontDisplay, fontSize: 28, fontWeight: 400, lineHeight: 1.15, letterSpacing: '-0.02em', margin: '0 0 16px', color: T.ink }}>Rules for high-rise and rope-access window work</h2>
      <p data-rule="height" style={{ fontSize: 16, lineHeight: 1.65, color: T.ink, margin: 0 }}>{v.text}</p>
      <p style={{ fontFamily: fontMono, fontSize: 11, lineHeight: 1.6, color: T.inkSoft, margin: '8px 0 0' }}>
        {v.sources.map((s, i) => <span key={s.url}>{i ? ' · ' : ''}<a href={s.url} rel="nofollow noopener" target="_blank" style={{ color: 'inherit' }}>{s.title}</a></span>)} · checked {checked(v.asOf)} · <Link to="/methodology#local-rules" style={{ color: 'inherit' }}>How we check local rules</Link>
      </p>
    </div>
  );
}
